import { render, staticRenderFns } from "./memberManagement.vue?vue&type=template&id=4540df28&scoped=true"
import script from "./memberManagement.vue?vue&type=script&lang=js"
export * from "./memberManagement.vue?vue&type=script&lang=js"
import style0 from "./memberManagement.vue?vue&type=style&index=0&id=4540df28&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4540df28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4540df28')) {
      api.createRecord('4540df28', component.options)
    } else {
      api.reload('4540df28', component.options)
    }
    module.hot.accept("./memberManagement.vue?vue&type=template&id=4540df28&scoped=true", function () {
      api.rerender('4540df28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/memberManagement.vue"
export default component.exports